export const ENGLISH = {
	COMPLTETE_YOUR_PAYMANT: 'Complete Your Payment',
	UPI_ENTERED: 'UPI ID / VPA Entered:',
	OPEN: 'Open',
	CHECK_PENDING_REQUEST: 'Check pending requests & enter UPI PIN to pay',
	SOMETHING_WENT_WRONG: 'Something Went Wrong',
	TRY_AGAIN: 'Try Again',
	BALANCE: 'Balance',
	RECOMMENDED: 'Recommended',
	SAFE_SECURE: '100% SAFE & SECURE',
	PROCESSING_PAYMENT: 'We are processing your payment...',
	TAKING_LONGER: 'This is taking longer than usual. Please wait...',
	WANT_TO_EXIT: 'Are you sure you want to exit?',
	YES: 'Yes',
	NO: 'No',
	CANCEL: 'Cancel',
	SELECT_PAYMENT_METHOD: 'Select Payment Method',
	BHARATPE: 'BharatePe',
	ENETR_OTP_SENT_TO: 'Please enter the OTP sent to',
	VERIFY_OTP: 'Verify OTP',
	INVALID_UPI_VPA: 'Invalid UPI ID / VPA Please Try again',
	CHOOSE_UPI_HANLDE: 'Choose UPI Handle',
	VPA_SELECTED: 'VPA Selected',
	PAY: 'Pay',
	PAYMANT_BY_UPI: 'Payment By UPI',
	SUB_Header_Text: 'Paying to:',
	Amount: 'Amount',
	X_Fast_Tag: 'x 2FASTag',
	COMPLETE_YOUR_PAYMENT: 'Complete Your Payment',
	ID_VPA_ENETERED: 'ID / VPA entered: ',
	GOOGLE_PAY: 'Google Pay ',
	APP: 'App',
	CHECKING_PAYMENT_REQUEST: 'Check pending requests &\n',
	COMPLETE_THIS_PAYMENT_IN: 'Complete this payment in',
	DONT_GO_BACK: `Please don't go back or refresh until payment is completed`,
	SAFE_AND_SECURE: '100% SAFE & SECURE',
	TRANSACTION_STATUS: 'Check Transaction Status',
	ENTER_YOUR_UPI_ID_VPA: 'Enter your UPI ID / VPA',
};
